'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:travelmerchant:check_printer_state');
}

var _invoke = require('../invoke');

/**
 * 打印状态
 *
 * @memberof travel
 * @static
 * @name check_printer_state
 * @return {Promise}
 * @example
 *  hbnb.travel.printerState()
 *      .then(function(resp) {
 *          resp = {
 *              status:""//一共五种状态：OK,NO_PAPER（缺纸）,HIGH_TEMP（过热）,ERROR(过热且缺纸),UNKNOW(未知)
 *          }
 *      });
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        //debug('city is %s');
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('travelmerchant', 'check_printer_state', {
            callback: function(resp) {
                resolve(resp);
            },
            complete: function (resp) {
                reject(resp);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/travel/biz-pos-printer.js
// module id = 643
// module chunks = 0